import {
	AnswerKeys,
	EducationValues,
	GoalCategory,
	GoalValues,
	GpaRanges,
	TimeToCompleteValues,
	WeeklyTimeValues,
} from './types';

export const screenSelectionTypeMap = {
	[AnswerKeys.feeling]: 'singleChoice',
	[AnswerKeys.education]: 'singleChoice',
	[AnswerKeys.goal]: 'singleChoice',
	[AnswerKeys.credits]: 'singleChoice',
	[AnswerKeys.hsGpa]: 'singleChoice',
	[AnswerKeys.collegeGpa]: 'singleChoice',
	[AnswerKeys.interests]: 'multipleChoice',
	[AnswerKeys.timeToComplete]: 'singleChoice',
	[AnswerKeys.weeklyTime]: 'singleChoice',
};

export const goalsFacetMap = {
	[GoalValues.college]: ['Go to College', 'Prepare for College'],
	[GoalValues.masters]: ["Earn a Master's Degree"],
	[GoalValues.certificate]: ['Advance your career'],
	[GoalValues.highschool]: ['Finish high school'],
	[GoalValues.language]: ['Learn a Language'],
};

export const educationalGoals: GoalCategory[] = [
	{
		name: GoalValues.highschool,
		facets: ['Finish High School'],
		nonDegree: true,
		disabled: false,
	},
	{
		name: GoalValues.college,
		facets: ['Go to College'],
		disabled: false,
	},
	{
		name: GoalValues.masters,
		facets: ["Earn a Master's Degree"],
		disabled: false,
	},
	{
		name: GoalValues.language,
		facets: ['Learn a Language'],
		nonDegree: true,
		disabled: false,
	},
	{
		name: GoalValues.certificate,
		facets: ['Advance your career'],
		nonDegree: true,
		disabled: false,
	},
];

export const educationFacetMap = {
	[EducationValues['Some high school']]: [
		'Finish High School',
		'Learn a Language',
		'Advance your career',
	],
	[EducationValues['High school diploma']]: [
		'Advance your career',
		'Go to College',
		'Learn a Language',
		'Prepare for College',
	],
	[EducationValues['Some college credits']]: [
		'Advance your career',
		'Go to College',
		'Learn a Language',
	],
	[EducationValues['Associate degree']]: [
		'Advance your career',
		'Go to College',
		'Learn a Language',
	],
	[EducationValues["Bachelor's degree"]]: [
		'Advance your career',
		"Earn a Master's Degree",
		'Go to College',
		'Learn a Language',
	],
	[EducationValues["Master's degree or higher"]]: [
		'Advance your career',
		'Go to College',
		"Earn a Master's Degree",
		'Learn a Language',
	],
};

export const eduLevelMap = {
	[EducationValues['Some high school']]: [0, 0],
	[EducationValues['High school diploma']]: [0, 1],
	[EducationValues['Some college credits']]: [0, 2],
	[EducationValues['Associate degree']]: [0, 2],
	[EducationValues["Bachelor's degree"]]: [0, 3],
	[EducationValues["Master's degree or higher"]]: [0, 3],
};

export const gpaMap = {
	[GpaRanges.threePointFive]: 3.5,
	[GpaRanges.threePointZero]: 3.0,
	[GpaRanges.twoPointFive]: 2.5,
	[GpaRanges.twoPointZero]: 2.0,
	[GpaRanges.onePointZero]: 1.0,
};

export const timeToCompleteMap = {
	[TimeToCompleteValues.upToTwoMonths]: 60,
	[TimeToCompleteValues.upToSixMonths]: 180,
	[TimeToCompleteValues.upToTwoYears]: 720,
	[TimeToCompleteValues.upToFourYears]: 1440,
	[TimeToCompleteValues.moreThanFourYears]: 1440,
};

export const weeklyTimeMap = {
	[WeeklyTimeValues.upToTwo]: 2,
	[WeeklyTimeValues.upToSix]: 6,
	[WeeklyTimeValues.upToTwelve]: 12,
	[WeeklyTimeValues.upToTwentyFour]: 24,
};
